'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Prompt } from 'react-router'

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup';

import TitleNewUser from './TitleNewUser';
import SaveCancelButton from './SaveCancelButton';
import UserInfo from './UserInfo';
import UserProfile from './UserProfile';
import UserAccessConfiguration from "./UserAccessConfiguration";

let seModifico = false;
class AltaModUsuario extends Component {
    constructor(props) {
        super(props);        
    }   

    componentDidMount() {

        window.onbeforeunload = function (event) {
            if (seModifico) {
                return "¿Quieres salir de este sitio web? Los cambios no se guardarán.";
            }
        }
        this.props.resetState();
        const userToEditId = this.props.match.params.id;
        this.props.getData(userToEditId, this.props.currentScope);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.data.messageHidden) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }
    }

    componentWillUnmount() {
        seModifico = false;
        this.props.resetState();
    }

    render() {
        let component = null;
        let spinner = null;
        let redirect = null;

        seModifico = this.props.data.usuarioConCambios;

        //Cambia la redirección dependiendo si es edición o no
        if (this.props.data.selectedUserId > 0) {
            redirect = <Redirect to={ProcessManager.GetNextStep("AltaModUsuario", "ROUTE_TO_VISTA_USUARIO") + '/' + this.props.data.selectedUserId} />;
        }
        else {
            redirect = <Redirect to={ProcessManager.GetNextStep("AltaModUsuario", "ROUTE_TO_LISTA_USUARIO")} />;
        }

        if (this.props.data.redirect == true) {
            return redirect;
        }

        if (this.props.data.isFetching == true)
            spinner = <div className="loading" />

        if (this.props.data.functions != undefined) {
            let functions = this.props.data.functions;

            if (functions.Consulta == true) {
                component = (
                    <div className="container-fluid concierge">
                        {spinner}

                        {/*POP UP*/}
                        <MessagePopup isHidden={this.props.data.messageHidden}
                            message={this.props.data.message}
                            classMessage={this.props.data.messageClass} />

                        <TitleNewUser
                            informacionUsuario={this.props.data.informacionUsuario}
                            selectedUserId={this.props.data.selectedUserId} />
                        <SaveCancelButton
                            selectedUserId={this.props.data.selectedUserId}
                            usuarioConCambios={this.props.data.usuarioConCambios}
                            informacionUsuario={this.props.data.informacionUsuario}
                            estadoActual={this.props.data.estadoActual}
                            createUsuario={this.props.createUsuario}
                            editUsuario={this.props.editUsuario}
                            cancelClick={this.props.cancelClick} />
                        <UserInfo
                            usuariosActuales={this.props.data.usuariosActuales}
                            productos={this.props.data.productos}
                            informacionUsuario={this.props.data.informacionUsuario}
                            sectores={this.props.data.sectores}
                            sucursales={this.props.data.sucursales}
                            updateInformacionUsuario={this.props.updateInformacionUsuario} />
                        <UserProfile
                            /*PERFILES*/
                            perfiles={this.props.data.perfiles}
                            perfilesFiltrados={this.props.data.perfilesFiltrados}
                            perfilesDelUsuario={this.props.data.perfilesDelUsuario}
                            productos={this.props.data.productos}
                            getPerfilesByProducto={this.props.getPerfilesByProducto}
                            limpiarPerfilesFiltrados={this.props.limpiarPerfilesFiltrados}
                            createPerfil={this.props.createPerfil}
                            addPerfilUsuario={this.props.addPerfilUsuario}
                            deletePerfilUsuario={this.props.deletePerfilUsuario}
                            informacionUsuario={this.props.data.informacionUsuario}
                            updateInformacionUsuario={this.props.updateInformacionUsuario}
                            productoSinPerfil={this.props.data.productoSinPerfil}

                            /*PERMISOS*/
                            permisos={this.props.data.permisos}
                            addPermiso={this.props.addPermiso}
                            deletePermiso={this.props.deletePermiso}

                            selectProductoPermiso={this.props.selectProductoPermiso}
                            selectCategoriaPermiso={this.props.selectCategoriaPermiso}
                            selectProgramaPermiso={this.props.selectProgramaPermiso}
                            addFuncion={this.props.addFuncion}
                            removeFuncion={this.props.removeFuncion}
                            configuracionPwType={this.props.data.configuracionPwType}
                            gruposWindows={this.props.data.gruposWindows}
                            gruposWindowsSeleccionados={this.props.data.gruposWindowsSeleccionados}
                            addGroupWindows={this.props.addGroupWindows}
                            deleteGroupWindows={this.props.deleteGroupWindows}
                            resetGrupoWindows={this.props.resetGrupoWindows} />

                        <UserAccessConfiguration
                            selectedUserId={(this.props.data.selectedUserId)}
                            isGyFSecurity={this.props.data.esSeguridadGyf}
                            informacionUsuario={this.props.data.informacionUsuario}
                            modoExclusivo={this.props.data.modoExclusivo}
                            configuracionPwSesion={this.props.data.configuracionPwSesion}
                            productos={this.props.data.productos}
                            tipoPlataforma={this.props.data.tipoPlataforma}
                            accesosPorPlataforma={this.props.data.accesosPorPlataforma}
                            addModoExclusivo={this.props.addModoExclusivo}
                            deleteModoExclusivo={this.props.deleteModoExclusivo}
                            setAccesosSimultaneosPorPlataforma={this.props.setAccesosSimultaneosPorPlataforma}
                            updateInformacionUsuario={this.props.updateInformacionUsuario}
                            passWordChange={this.props.passWordChange}
                            passWordUnChange={this.props.passWordUnChange} />
                        <SaveCancelButton
                            selectedUserId={this.props.data.selectedUserId}
                            usuarioConCambios={this.props.data.usuarioConCambios}
                            informacionUsuario={this.props.data.informacionUsuario}
                            estadoActual={this.props.data.estadoActual}
                            createUsuario={this.props.createUsuario}
                            editUsuario={this.props.editUsuario}
                            cancelClick={this.props.cancelClick} />
                    </div>
                );
            } else {

                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                component = (
                    <div>
                        {
                            spinner ? spinner : <GenericErrorScreen data={values} />
                        }
                        <GenericErrorScreen data={values} />
                    </div>);
            }

            return (component);
        } else {
            return spinner;
        }
    }
}

export default AltaModUsuario;